'use client';

import type { ReactNode } from 'react';
import { cn } from '../ui/utils';

interface SuccessScreenProps {
  headline?: string;
  message?: string;
  className?: string;
  icon?: ReactNode;
}

export const SuccessScreen = ({
  headline = 'Thank you, enjoy!',
  message,
  className,
  icon,
}: SuccessScreenProps) => {
  return (
    <div
      className={cn(
        'text-center flex flex-col items-center bg-nimbus-background text-nimbus-foreground',
        className
      )}
      data-testid="bx-forms-success"
    >
      <h2 className="mb-4 text-[32px] leading-10 tracking-[-1px] font-bold text-nimbus-foreground">
        {headline}
      </h2>
      {message && (
        <p className="mb-8 text-base leading-6 text-nimbus-muted-foreground">
          {message}
        </p>
      )}
      {icon}
    </div>
  );
};
